import { render, staticRenderFns } from "./SupplierShow.vue?vue&type=template&id=143a5c16&"
import script from "./SupplierShow.vue?vue&type=script&lang=js&"
export * from "./SupplierShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports